export default __webpack_public_path__ + "static/media/655.6fee9b3a.png";